/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_ORGANIZATION,
  LOAD_ORGANIZATION_SUCCESS,
  LOAD_ORGANIZATION_ERROR,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_BUSINESS_META_DATA,
  LOAD_BUSINESS_META_DATA_SUCCESS,
  LOAD_BUSINESS_META_DATA_ERROR,
  LOAD_USER_ROLE,
  LOAD_USER_ROLE_SUCCESS,
  LOAD_USER_ROLE_ERROR,
  LOAD_TOKEN_EXPIRY,
  LOAD_TOKEN_EXPIRY_SUCCESS,
  LOAD_TOKEN_EXPIRY_ERROR,
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_ERROR,
  LOAD_USER_ACTIVITIES,
  LOAD_USER_ACTIVITIES_SUCCESS,
  LOAD_USER_ACTIVITIES_ERROR,
} from "./constants";

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE  organization_list
  };
}

//loadOrganizationList
export function loadOrganizationList(searchFilter) {
  return {
    type: LOAD_ORGANIZATION,
    searchFilter,
  };
}

export function loadOrganizationListSuccess(organization_list, success) {
  return {
    type: LOAD_ORGANIZATION_SUCCESS,
    organization_list,
    success,
  };
}

export function loadOrganizationListError(error) {
  return {
    type: LOAD_ORGANIZATION_ERROR,
    error,
  };
}

//users
export function loadUsers(searchFilter) {
  return {
    type: LOAD_USERS,
    searchFilter,
  };
}

export function loadUsersSuccess(users_list, success) {
  return {
    type: LOAD_USERS_SUCCESS,
    users_list,
    success,
  };
}

export function loadUsersError(error) {
  return {
    type: LOAD_USERS_ERROR,
    error,
  };
}
//user role
export function loadUserRole(searchFilter) {
  return {
    type: LOAD_USER_ROLE,
    searchFilter,
  };
}

export function loadUserRoleSuccess(user_role_list, success) {
  return {
    type: LOAD_USER_ROLE_SUCCESS,
    user_role_list,
    success,
  };
}

export function loadUserRoleError(error) {
  return {
    type: LOAD_USER_ROLE_ERROR,
    error,
  };
}

//token expiry
export function loadTokenExpiry(searchFilter) {
  return {
    type: LOAD_TOKEN_EXPIRY,
    searchFilter,
  };
}

export function loadTokenExpirySuccess(token_expiry_list, success) {
  return {
    type: LOAD_TOKEN_EXPIRY_SUCCESS,
    token_expiry_list,
    success,
  };
}

export function loadTokenExpiryError(error) {
  return {
    type: LOAD_TOKEN_EXPIRY_ERROR,
    error,
  };
}

// activities
export function loadActivities(searchFilter) {
  return {
    type: LOAD_USER_ACTIVITIES,
    searchFilter,
  };
}

export function loadActivitiesSuccess(user_activities, success) {
  return {
    type: LOAD_USER_ACTIVITIES_SUCCESS,
    user_activities,
    success,
  };
}

export function loadActivitiesError(error) {
  return {
    type: LOAD_USER_ACTIVITIES_ERROR,
    error,
  };
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  };
}

export function loadBusinessMetaData() {
  return {
    type: LOAD_BUSINESS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadBusinessMetaDataSuccess(businessMetaData) {
  return {
    type: LOAD_BUSINESS_META_DATA_SUCCESS,
    businessMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadBusinessMetaDataError(error) {
  return {
    type: LOAD_BUSINESS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadOrganizationList,
  loadOrganizationListSuccess,
  loadOrganizationListError,
  loadUserRole,
  loadUserRoleSuccess,
  loadUserRoleError,
  loadUsers,
  loadUsersSuccess,
  loadUsersError,
  loadTokenExpiry,
  loadTokenExpirySuccess,
  loadTokenExpiryError,
  loadActivities,
  loadActivitiesSuccess,
  loadActivitiesError,

  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadBusinessMetaData,
  loadBusinessMetaDataSuccess,
  loadBusinessMetaDataError,
};

export default actions;
